module.exports = __webpack_public_path__ + "img/faq_ellipse.b835902c.png";